import { MapIconButton } from "@vilocnv/allsetra-core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import { Box } from "@mui/material";
import {
  ClusterIcon,
  ClusterIconBlack,
  GeozoneIcon,
  GeozoneIconBlack,
  TrafficIcon,
  TrafficIconBlack
} from "assets/icons";

interface DashboardMapActionsButtonsProps {
  showSatelliteMode: boolean;
  onShowSatelliteButtonClick: () => void;

  showClusters: boolean;
  onShowClustersButtonClick: () => void;

  showTraffic: boolean;
  onShowTrafficButtonClick: () => void;

  showGeozones: boolean;
  onShowGeozonesButtonClick: () => void;

  autoFitVisibleUnits: boolean;
  onAutoFitVisibleUnitsButtonClick: () => void;
}

const DashboardMapActionsButtons: FC<DashboardMapActionsButtonsProps> = ({
  showSatelliteMode,
  onShowSatelliteButtonClick,
  showClusters,
  onShowClustersButtonClick,
  showTraffic,
  onShowTrafficButtonClick,
  showGeozones,
  onShowGeozonesButtonClick,
  autoFitVisibleUnits,
  onAutoFitVisibleUnitsButtonClick
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        padding: 1,
        display: "flex",
        gap: "4px",
        flexDirection: "row-reverse"
      }}
    >
      <MapIconButton
        tooltipTitle={
          showSatelliteMode
            ? t("common.showMapMode")
            : t("common.showSatelliteMode")
        }
        active={showSatelliteMode}
        onClick={onShowSatelliteButtonClick}
      >
        <SatelliteAltIcon
          sx={{
            color: showSatelliteMode ? "black" : "#959EB3"
          }}
          fontSize="small"
        />
      </MapIconButton>
      <MapIconButton
        tooltipTitle={
          showClusters
            ? t("common.disableClustering")
            : t("common.enableClustering")
        }
        active={showClusters}
        onClick={onShowClustersButtonClick}
      >
        {!showClusters ? <ClusterIcon /> : <ClusterIconBlack />}
      </MapIconButton>
      <MapIconButton
        tooltipTitle={
          showTraffic ? t("common.hideTraffic") : t("common.toggleTraffic")
        }
        active={showTraffic}
        onClick={onShowTrafficButtonClick}
      >
        {!showTraffic ? <TrafficIcon /> : <TrafficIconBlack />}
      </MapIconButton>
      <MapIconButton
        tooltipTitle={
          showGeozones ? t("common.hideGeozones") : t("common.toggleGeozones")
        }
        active={showGeozones}
        onClick={onShowGeozonesButtonClick}
      >
        {!showGeozones ? <GeozoneIcon /> : <GeozoneIconBlack />}
      </MapIconButton>
      <MapIconButton
        tooltipTitle={
          autoFitVisibleUnits
            ? t("common.showMapOverview")
            : t("common.fitMapToVisibleUnits")
        }
        active={autoFitVisibleUnits}
        onClick={onAutoFitVisibleUnitsButtonClick}
      >
        <FitScreenIcon
          sx={{
            color: autoFitVisibleUnits ? "black" : "#959EB3"
          }}
          fontSize="small"
        />
      </MapIconButton>
    </Box>
  );
};

export default DashboardMapActionsButtons;
